var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-icon',{staticClass:"spinner-icon",attrs:{"large":"","color":"blue-grey darken-2"}},[_vm._v(" mdi-autorenew ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }